import { OnDestroy, Directive } from '@angular/core';
import { Subject } from 'rxjs';

/**
 * Base class that provides automatic subscription cleanup
 * Usage: extend your component from this class and use .pipe(takeUntil(this.destroy$))
 */
@Directive()
export abstract class DestroyHelper implements OnDestroy {
  protected destroy$ = new Subject<void>();

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
